class EuroAboutWays extends HTMLElement {
  connectedCallback() {
    this.mq = window.matchMedia('(min-width: 1200px)');
    this.desktopEl = this.querySelector('[data-about-ways-desktop]');
    this.mobileEl = this.querySelector('[data-about-ways-mobile]');
    this.dotsEl = this.querySelector('[data-about-ways-dots]');
    this.onChange = () => this.sync();
    this.onDesktopClick = (event) => {
      const button = event.target.closest('[data-about-ways-index]');
      if (!button || !this.desktopSwiper) return;
      const index = Number(button.dataset.aboutWaysIndex);
      if (Number.isNaN(index)) return;
      this.desktopSwiper.slideTo(index);
    };

    this.desktopEl?.addEventListener('click', this.onDesktopClick);
    this.mq.addEventListener('change', this.onChange);
    this.whenReady(() => this.sync());
  }

  disconnectedCallback() {
    this.mq?.removeEventListener('change', this.onChange);
    this.desktopEl?.removeEventListener('click', this.onDesktopClick);
    clearInterval(this.readyTimer);
    this.destroy();
  }

  whenReady(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    this.readyTimer = setInterval(() => {
      if (!window.Swiper) return;
      clearInterval(this.readyTimer);
      callback();
    }, 30);
  }

  sync() {
    this.destroy();
    if (this.mq.matches) {
      this.initDesktop();
    } else {
      this.initMobile();
    }
  }

  initialIndex(count) {
    if (count >= 2) return 1;
    return 0;
  }

  initDesktop() {
    if (!this.desktopEl || !window.Swiper) return;

    const slides = this.desktopEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (!count) return;

    this.desktopSwiper = new window.Swiper(this.desktopEl, {
      direction: 'vertical',
      slidesPerView: Math.min(3, count),
      centeredSlides: true,
      initialSlide: this.initialIndex(count),
      speed: 450,
      watchOverflow: true,
      allowTouchMove: false,
      simulateTouch: false,
    });

    window.EuroAOS?.refresh();
  }

  initMobile() {
    if (!this.mobileEl || !window.Swiper) return;

    const slides = this.mobileEl.querySelectorAll('.swiper-slide');
    const count = slides.length;
    if (!count) return;

    if (count <= 1) {
      if (this.dotsEl) this.dotsEl.hidden = true;
      window.EuroAOS?.refresh();
      return;
    }

    this.mobileSwiper = new window.Swiper(this.mobileEl, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: this.initialIndex(count),
      speed: 400,
      watchOverflow: true,
      pagination: this.dotsEl
        ? {
            el: this.dotsEl,
            clickable: true,
            bulletClass: 'euro-about-ways__dot',
            bulletActiveClass: 'is-active',
          }
        : undefined,
      on: {
        slideChange: (swiper) => {
          const slide = swiper.slides?.[swiper.activeIndex];
          if (slide) window.EuroAOS?.replayIn(slide);
        },
      },
    });

    window.EuroAOS?.refresh();
  }

  destroy() {
    this.desktopSwiper?.destroy(true, true);
    this.mobileSwiper?.destroy(true, true);
    this.desktopSwiper = null;
    this.mobileSwiper = null;
    if (this.dotsEl) this.dotsEl.hidden = false;
  }
}

if (!customElements.get('euro-about-ways')) {
  customElements.define('euro-about-ways', EuroAboutWays);
}
